// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid.screenings {
  grid-template-columns: repeat(9, auto);
}
.full-grid-row {
  background-color: rgba(108, 117, 125, 0.5);
  grid-column-start: 1;
  grid-column-end: 10;
}
`, "",{"version":3,"sources":["webpack://./src/app/packages-module/components/editable-search-list/editable-search-list.component.less"],"names":[],"mappings":"AAEA;EACI,sCAAA;AADJ;AAIA;EACI,0CAAA;EACA,oBAAA;EACA,mBAAA;AAFJ","sourcesContent":["@rowCount : 9;\n\n.grid.screenings {\n    grid-template-columns: repeat(@rowCount, auto);\n}\n\n.full-grid-row {\n    background-color: rgba(108,117,125,.5);\n    grid-column-start: 1;\n    grid-column-end: @rowCount + 1;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
